import axios from "axios"

export const GetVcByKioskId = async (kioskId) => {
     const data = await axios.get(`${process.env.REACT_APP_BACKEND_API}/api/vc/getVcByKioskId/${kioskId}`,)
     return data.data.data.result
}